import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SurveyListItemBox from '@ui-parts/SurveyListItemBox';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import { callThunk, fetchSurveys } from '~/api';
import { FONT_SIZES } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const MyPageWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const SurveyListWrapper = styled.div`
  display: inline-block;
  margin: 0 auto;
  padding: 3px;
  width: 960px;
`;

const TitleWrapper = styled.div`
  width: 100%;
  text-align: left;
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

const Title = styled(Typography)`
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

function Mypage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const surveys = useSelector((state) => state.surveys);
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const {
        payload: { result },
      } = await dispatch(
        callThunk({
          action: fetchSurveys,
          payload: {
            surveyStatusIds: '',
          },
        })
      );

      // APIレスポンスのアンケートリストが空だったら新規作成に遷移
      if (Array.isArray(result) && result.length === 0) {
        navigate(ROUTES.USER.SURVEY_REGISTER_TYPE_SELECTION, {
          state: { referrer: window.location.pathname },
        });
      }
    })();
  }, []);

  return (
    <MyPageWrapper>
      <SurveyListWrapper>
        <TitleWrapper>
          <Title>{t('appCommon.enqueteList')}</Title>
        </TitleWrapper>
        {Array.isArray(surveys) &&
          surveys.length > 0 &&
          surveys.map((survey) => {
            return <SurveyListItemBox survey={survey} key={survey.id} />;
          })}
      </SurveyListWrapper>
    </MyPageWrapper>
  );
}

export default Mypage;
